<crm-auto-complete
  #bankDetailAutoComplete
  [(value)]="selectedBankDetail"
  (valueChange)="selectedBankDetailChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="bankDetails"
  [virtualScroll]="true"
  [virtualScrollItemSize]="64"
  [inputStyleClass]="inputStyleClass"
  optionLabel="checkingAccount"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [isError]="isError"
  (completeMethod)="customSearch ? bankDetailsSearch.emit($event.query) : searchBankDetails($event.query)">
  <ng-template
    let-item="item"
    #itemTemplate>
    <div
      *ngIf="toBankDetail(item) as bankDetail"
      class="white-space-normal">
      <div class="mb-1">{{ bankDetail?.name }}</div>
      <div class="text-gray-500">
        <span [innerHTML]="highlightMatchText(bankDetail.checkingAccount) | safeHtml"></span>
      </div>
    </div>
  </ng-template>
</crm-auto-complete>
